import {DrupalDocumentMedia} from "../types/hygiena-types";
import {absoluteURL} from "./absolute-url";

/**
 * Will return a more friendly uri for the document.
 *
 * @param document
 */
export function getDocumentUri(document: DrupalDocumentMedia) {
  const pieces = ['/documents'];
  let mediaId = document?.drupal_internal__mid ?? document?.id ?? '';

  // Return the original URL if there's no numeric media id.
  if (isNaN(parseInt(mediaId))) {
    let url = document?.path?.uri?.url ?? document?.field_media_file?.uri?.uri ?? document?.uri ?? '';
    if (url.match(/^(\w+:\/\/|\/\/)/)) {
      return url;
    }
    return absoluteURL(url);
  }

  const slugify = (text: string) => {
    return text.toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/^\W+/g, "");
  }

  pieces.push(mediaId);

  if (document?.name) {
    pieces.push(slugify(document.name) + '.pdf')
  }

  return pieces.join('/');
}